export default __webpack_public_path__ + "static/2_3-6d7678e0d48fd09d56a9651adcec3b62.jpg";